export type ErrorNotice = { id: number; message: string };
let notices: ErrorNotice[] = [];
let nextId = 0;
const listeners = new Set<() => void>();
export function reportError(error: unknown) {
  const message = (
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "Something went wrong. Please try again."
  ).slice(0, 400);
  // React and window.onerror may both report one failure. Dismissed errors
  // can be reported again if a subsequent attempt fails.
  if (notices.some((notice) => notice.message === message)) return;
  notices = [...notices.slice(-2), { id: ++nextId, message }];
  listeners.forEach((listener) => listener());
}
export function dismissError(id: number) {
  notices = notices.filter((notice) => notice.id !== id);
  listeners.forEach((listener) => listener());
}
export const errorNotices = {
  getSnapshot: () => notices,
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
